import { Col } from './cols/col.class';
import { AbstractTable } from './context/abstract/table.class';

export class Dragger<D extends object> {
   private dragInfo: DragInfo<D>;
   public isDragging = false;

   constructor(
      readonly ctx: AbstractTable<D>,
   ) { }

   public mouseDown(e: MouseEvent, col: Col<D>) {
      const { visible } = this.ctx.cols;
      const fixedWidth = visible
         .filter(({ isPinned: isFixed }) => isFixed)
         .reduce((total, { dom }) => total + dom.offsetWidth, 0);
      const dragableWidth = visible
         .filter($col => $col !== col)
         .reduce((total, { dom }) => total + dom.offsetWidth, 0);

      this.dragInfo = {
         curr: col,
         dragableWidth,
         fixedWidth,
         inParrOffset: 0,
         windowOffset: e.pageX,
         avatar: null,
      };

      this.isDragging = true;
      document.body.style.userSelect = 'none';
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
   }

   private onMouseMove = (e: MouseEvent) => {
      const { windowOffset, inParrOffset, curr, avatar, dragableWidth, fixedWidth } = this.dragInfo;
      const { draggable } = this.ctx.cols;
      const movement = e.pageX - windowOffset;
      const newInParrOffset = inParrOffset + movement;
      const prev = draggable.find($col => $col.order === curr.order - 1);
      const next = draggable.find($col => $col.order === curr.order + 1);
      const goingLeft = movement < 0;
      const goingRigth = movement > 0;

      if (!avatar && movement < 20) {
         this.dragInfo.avatar = this.createAvatar();
      }

      if (newInParrOffset > fixedWidth && newInParrOffset < dragableWidth) {
         avatar.style.left = newInParrOffset + 'px';
      }

      if (prev && goingLeft && Math.abs(movement) > prev.dom.offsetWidth / 2) {
         this.switch(curr, prev, -1);
         this.dragInfo.inParrOffset -= prev.dom.offsetWidth;
         this.dragInfo.windowOffset -= prev.dom.offsetWidth;
      } else if (next && goingRigth && Math.abs(movement) > next.dom.offsetWidth / 2) {
         this.switch(curr, next, 1);
         this.dragInfo.inParrOffset += next.dom.offsetWidth;
         this.dragInfo.windowOffset += next.dom.offsetWidth;
      }

   }

   private onMouseUp = (e: MouseEvent) => {
      if (this.dragInfo.avatar) {
         this.dragInfo.avatar.remove();
         this.dragInfo.curr.dom.style.visibility = null;
      }
      document.body.style.userSelect = null;
      this.isDragging = false;
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
   }

   private createAvatar(): HTMLDivElement {
      const col = this.dragInfo.curr;
      const avatar = this.dragInfo.curr.dom.cloneNode(true) as HTMLDivElement;
      const leftOffset = this.ctx.cols.visible
         .filter($col => $col.order < col.order)
         .reduce((total, $col) => total + $col.dom.offsetWidth, 0);

      avatar.classList.add('avatar');
      avatar.style.left = leftOffset + 'px';
      avatar.style.width = col.dom.offsetWidth + 'px';


      this.dragInfo.inParrOffset = leftOffset;
      this.dragInfo.curr.dom.style.visibility = 'hidden';

      return this.ctx.dom.header.appendChild(avatar);
   }

   private switch(first: Col<D>, second: Col<D>, direction: 1 | -1) {
      first.order += direction;
      second.order -= direction;
      this.ctx.cols.reseter.organize();
   }
}

interface DragInfo<D extends object> {
   curr: Col<D>;
   dragableWidth: number;
   fixedWidth: number;
   inParrOffset: number;
   windowOffset: number;
   avatar: HTMLDivElement;
}
